module.exports = __webpack_public_path__ + "img/calligraphy-test-icon1.bec58e82.jpg";